import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { Delegation, DelegationAddEdit } from 'src/app/delegations/models/delegation';
import { DelegationUser } from 'src/app/delegations/models/delegation-user';

@Injectable({
    providedIn: 'root'
})
export class DelegationsService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'AyaNova', 'delegations');
    }

    createDelegation(delegation: DelegationAddEdit): Observable<void> {
        return this.http.post<void>(`${this.coreApiPath}`, delegation);
    }

    updateDelegation(delegation: DelegationAddEdit): Observable<void> {
        return this.http.put<void>(`${this.coreApiPath}/${delegation.id}`, delegation);
    }

    searchDelegationEmployees(query: string): Observable<DelegationUser[]> {
        const url = `${this.coreApiPath}/employees`;
        return this.http.get<DelegationUser[]>(`${url}?query=${query}`);
    }

    getDelegateeDelegations(delegateeId: string): Observable<Delegation[]> {
        const url = `${this.coreApiPath}/delegatee-delegations/${delegateeId}`;
        return this.http.get<Delegation[]>(url);
    }

    getOwnerDelegations(ownerId: string): Observable<Delegation[]> {
        const url = `${this.coreApiPath}/owner-delegations/${ownerId}`;
        return this.http.get<Delegation[]>(url);
    }

    setDelegationToInactive(userDelegateId: number): Observable<void> {
        const url = `${this.coreApiPath}/${userDelegateId}`;
        return this.http.delete<void>(url);
    }
}
